import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";

import Login from "./pages/Login";
import Home from "./pages/Home";
import Reports from "./pages/Reports";
import Manage from "./pages/Manage";
import Devices from "./pages/Devices";
import News from "./pages/News";
import Help from "./pages/Help";
import Settings from "./pages/Settings";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Login />
      </Route>
      <Route exact path="/home">
        <Home />
      </Route>
      <Route exact path="/reports">
        <Reports />
      </Route>
      <Route exact path="/Manage">
        <Manage />
      </Route>
      <Route exact path="/devices">
        <Devices />
      </Route>
      <Route exact path="/news">
        <News />
      </Route>
      <Route exact path="/help">
        <Help />
      </Route>
      <Route exact path="/settings">
        <Settings />
      </Route>
      <Route path="*">
        <Login />
      </Route>
    </Switch>
  );
};

const RouterNav = () => {
  return (
    <React.StrictMode>
      <Router>
        {/* <ScrollToTop /> */}
        <Routes />
      </Router>
    </React.StrictMode>
  );
};

export default RouterNav;
